module.exports = "<list-view\n  active-params=\"$ctrl.activeParams\"\n  filter-event=\"$ctrl.filterEvent\"\n  page=\"$ctrl.page\"\n  total=\"$ctrl.total\"\n  limit=\"$ctrl.limit\"\n  paginate-event=\"$ctrl.paginateEvent\"\n  title=\"Topups\"\n  resource=\"Topup\"\n  transformer=\"TopupsTransforms\"\n  no-items-text=\"No Topups Yet!\"\n></list-view>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\">\n  <main-sidenav></main-sidenav>\n</main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/topups/topups.html
// module id = 1435
// module chunks = 0